import axios from "axios";
import beveatApiResourceOwner from "../../../api/resource_owner_beveat_api.js";
import beveatApiStaging from "../../../api/staging_beveat_api.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Globe from "../../../assets/icons/globe.svg";
import Mortarboard from "../../../assets/icons/mortarboard.svg";
import ComingSoonModal from "../../components/coming_soon_modal.jsx";
import { commonConfigs, urls } from "../../../../config.js";
import ComboApiCatalogueCard from "./combo_api_catalogue_card.jsx";
import ProjectApiCatalogueCard from "../components/project_api_catalogue_card.jsx";
import PaymentsApiCatalogueCard from "./payments_api_catalogue_card.jsx";
import MembershipCard from "./membership_card.jsx";
import { getUser } from "../../../services/local_service.js";
import { INVOICE_PLAN_SYSCODE } from "../../../constants/invoice_plan_syscode.jsx";
import RenewProjectModal from "./renew_project_modal.jsx";
import { DEVELOPER_PROJ_STATUS } from "../../../constants/developer_proj_status.jsx";
import PayMembershipPlanModal from "./pay_membership_plan_modal.jsx";
import { InvoiceCategorySequenceString, INVOICE_CATEGORY_SEQUENCE } from "../../../constants/invoice_category_sequence.jsx";

export default function CertificationUatPlan({ currentTab, isMobile }) {
  const [isOpen, setOpen] = useState(false);
  const [isOpenMembershipCard, setOpenMembershipCard] = useState(false);
  const [isReuseProjModalOpen, setReuseProjModalOpen] = useState(false);
  const [certificationPlans, setCertificationPlans] = useState([]);
  const [developerPlan, setDeveloperPlan] = useState([]);
  const [devProj, setDevProject] = useState({});
  const [comingSoonDate, setComingSoonDate] = useState(null);
  const [industryApiOptions, setIndustryApiOptions] = useState([]);
  const [organisationApiOptions, setOrganisationApiOptions] = useState([]);
  const navigate = useNavigate();
  const ssoId = getUser()?.sso_id;
  const getStagingProjectsUrl = urls.baseUrl + commonConfigs.apiUrls.getProjects();
  const getCertificationPlansUrl = urls.resourceOwnerUrl + commonConfigs.apiUrls.getCertificationPlans();

  const handleComingSoonClick = (date) => {
    setComingSoonDate(date);
    setOpen(true);
  };

  const handleMembershipClick = (date) => {
    setOpenMembershipCard(true);
  };

  const groupByCategory = (plans) => {
    const grouped = plans.reduce((acc, item) => {
      const catName = item.invoice_plan_category;
      if (!acc[catName]) {
        acc[catName] = [];
      }
      acc[catName].push(item);
      return acc;
    }, {});

    // New rule-based scoring function using string match from constants
    const scoreCategory = (name) => {
      const lowerName = name.toLowerCase();

      for (const [key, value] of Object.entries(InvoiceCategorySequenceString)) {
        if (value.toLowerCase() === lowerName) {
          return Number(key); // category ID
        }
      }
      return 999; // fallback
    };

    // Sort based on category score
    const sorted = {};
    Object.keys(grouped)
      .sort((a, b) => scoreCategory(a) - scoreCategory(b))
      .forEach((key) => {
        sorted[key] = grouped[key];
      });

    return sorted;
  };

  const customOrder = [
    "nets qr",
    "enets",
    "nets click (android)",
    "nets click (ios)",
  ];

  const sortByCustomOrder = (plans) => {
    return [...plans].sort((a, b) => {
      const aIndex = customOrder.indexOf(a.invoice_plan.toLowerCase());
      const bIndex = customOrder.indexOf(b.invoice_plan.toLowerCase());
      return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
    });
  };

  const isNetsCard = (plan) => {
    const name = plan.invoice_plan.toLowerCase();
    return (
      ["nets qr", "enets", "nets click (android)", "nets click (ios)"].includes(name) &&
      currentTab.invoiceSyscode === plan.invoice_syscode
    );
  };


  const getBenefits = (industry, category) => {
    const lowerIndustry = industry.toLowerCase();

    const uatPaymentsCategory = InvoiceCategorySequenceString[INVOICE_CATEGORY_SEQUENCE.UAT_Payments].toLowerCase();

    if (category.toLowerCase() === uatPaymentsCategory) {
      switch (lowerIndustry) {
        case "nets qr":
          return [
            "2 Months Plan",
            "Includes NETS Transaction Validation and Tech Support",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS QR"],
            },
          ];
        case "enets":
          return [
            "2 Months Plan",
            "Includes NETS Transaction Validation and Tech Support",
            {
              title: "NETS Online Payment APIs",
              children: ["eNETS"],
            },
          ];
        case "nets click (android)":
          return [
            "2 Months Plan",
            "Includes NETS Transaction Validation and Tech Support",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS Click (Android)"],
            },
          ];
        case "nets click (ios)":
          return [
            "2 Months Plan",
            "Includes NETS Transaction Validation and Tech Support",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS Click (IOS)"],
            },
          ];
      }
    } else {
      // Default: NETS Online Payments Coursework or others
      switch (industry) {
        case "Food Services":
          return [
            "Full Stack Developer Coursework",
            "OPENAPIPAAS Product, Voice & NETS Online Payment APIs",
            "Order-Fulfillment APIs",
          ];
        case "Air Transport":
          return [
            "Full Stack Developer Coursework",
            "OPENAPIPAAS Product, Voice & NETS Online Payment APIs",
            "Order-Fulfillment APIs",
            "Drone Traffic Management APIs",
          ];
        case "Per UAT Certification":
          return [
            "2 Months Plan",
            "Includes NETS Transaction Validation and Tech Support",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS QR", "eNETS", "NETS Click"],
            },
          ];
        case "NETS QR":
          return [
            "4 Months Plan",
            "Full Stack Developer Coursework",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS QR"],
            },
          ];
        case "eNETS":
          return [
            "4 Months Plan",
            "Full Stack Developer Coursework",
            {
              title: "NETS Online Payment APIs",
              children: ["eNETS"],
            },
          ];
        case "NETS Click (Android)":
          return [
            "4 Months Plan",
            "Full Stack Developer Coursework",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS Click (Android)"],
            },
          ];
        case "NETS Click (IOS)":
          return [
            "4 Months Plan",
            "Full Stack Developer Coursework",
            {
              title: "NETS Online Payment APIs",
              children: ["NETS Click (IOS)"],
            },
          ];
        default:
          return [
            "Full Stack Developer Coursework",
            "OPENAPIPAAS Product, Voice & NETS Online Payment APIs",
            "Order-Fulfillment APIs",
          ];
      }
    }
  };

  async function getStagingApisData() {
    await beveatApiStaging
      .get(getStagingProjectsUrl, { headers: commonConfigs.apiHeader })
      .then((res) => {
        const projects = res.data.result.data;
        const industryApiOptions = projects.filter(
          (project) =>
            project.project_billing_config_id == 1 &&
            project.project_name.toLowerCase().includes("industry")
        );

        const organisationApiOptions = projects.filter(
          (project) =>
            project.project_billing_config_id == 1 &&
            !project.project_name.toLowerCase().includes("industry")
        );

        setIndustryApiOptions(industryApiOptions);
        setOrganisationApiOptions(organisationApiOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getAllCertificationPlans(currentTab) {
    await beveatApiResourceOwner
      .get(getCertificationPlansUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        let plans = res.data.result.data.filter((item) => item.invoice_plan_syscode === currentTab.invoicePlanSyscode && item.invoice_syscode === currentTab.invoiceSyscode);
        let groupedPlans = groupByCategory(plans);
        setCertificationPlans(groupedPlans);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getDeveloperProjectByPlan(planId) {
    const getDeveloperProjectByPlanUrl =
      urls.resourceOwnerUrl +
      commonConfigs.apiUrls.getDeveloperProjectByPlan(ssoId, planId);
    return await beveatApiResourceOwner
      .get(getDeveloperProjectByPlanUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        setDevProject(res.data.result.data);
        return res.data.result.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getStagingApisData().catch((err) => {
      console.log("err for staging projects: " + err);
    });
    getAllCertificationPlans(currentTab).catch((err) => {
      console.log("err for certification plans: " + err);
    });
  }, []);

  const handleApplyClick = async (plan) => {
    setDeveloperPlan(plan);
    const developerProject = await getDeveloperProjectByPlan(
      plan.org_invoice_plan_id
    ).catch((err) => {
      console.log("err for getting inactiveDevProject: " + err);
    });
    if (Object.keys(developerProject).length !== 0 && developerProject.developer_proj_status !== DEVELOPER_PROJ_STATUS.Active) {
      setReuseProjModalOpen(true);
    } else {
      const projectNamesString = plan.project_name_preset;
      const projectNames = projectNamesString
        .split("|")
        .map((name) => name.toLowerCase());
      const industryApis = industryApiOptions
        .filter((project) => projectNames.includes(project.project_name))
        .map((project) => ({
          value: project.project_id,
          label: project.project_name,
        }));
      const organisationApis = organisationApiOptions
        .filter((project) => projectNames.includes(project.project_name))
        .map((project) => ({
          value: project.project_id,
          label: project.project_name
        }));

      const presetOptions = {
        invoicePlanSyscode: plan.invoice_plan_syscode,
        invoiceRateSyscode: plan.invoice_rate_syscode,
        invoiceSyscode: plan.invoice_syscode,
        invoicePlan: plan.invoice_plan,
        industryApiOptions: industryApis,
        organisationApiOptions: organisationApis,
        subscriptionId: {
          value: plan.org_invoice_plan_id,
          label: plan.invoice_plan,
        },
      };
      navigate("/projects/create", {
        state: { presetOptions: presetOptions },
      });
    }
  };

  return (
    <>
      {/* Mobile-responsive header section */}
      <div
        className={`text-center rounded-2xl relative ${isMobile ? 'p-4 mt-2' : 'p-5 mt-2'}`}
        style={{
          backgroundColor: "#2b2d42",
          color: "white",
          borderRadius: "24px",
          margin: "0 auto",
          maxWidth: isMobile ? "100%" : "90%",
          boxShadow: isMobile ? "2px 4px 8px rgba(0,0,0,0.1)" : "5px 10px #EBECF0", // Added consistent shadow
        }}
      >
        <h1 className={`${isMobile ? 'mb-8 text-2xl' : 'mb-14 text-4xl'}`}>
          Sign up for CodeForeword Membership Today
        </h1>
      </div>

      {/* Mobile-responsive membership cards */}
      <div
        className={`${isMobile
          ? 'flex flex-col items-center justify-center gap-4 mt-4'
          : 'flex justify-center items-center gap-x-36 relative'
          }`}
        style={{ marginTop: isMobile ? "16px" : "-60px" }}
      >
        <div className={isMobile ? "w-full max-w-sm flex justify-center" : ""}>
          <MembershipCard
            text="Enjoy Up to 30% Discounts"
            header="Mortarboard Chapter Membership"
            icon={Mortarboard}
            onClick={() => handleMembershipClick()}
            isMobile={isMobile}
          />
        </div>
        <div className={isMobile ? "w-full max-w-sm flex justify-center" : ""}>
          <MembershipCard
            text="Enjoy Up to 20% Discounts"
            header="Globe Membership"
            icon={Globe}
            onClick={() => handleComingSoonClick("End June")}
            isMobile={isMobile}
          />
        </div>
      </div>

      {/* Mobile-responsive certification plans */}
      {Object.entries(certificationPlans).map(([category, plans]) => {
        // Only apply custom sorting for UAT Payments Certification
        const isUatPaymentsCategory =
          category.toLowerCase() ===
          InvoiceCategorySequenceString[INVOICE_CATEGORY_SEQUENCE.UAT_Payments].toLowerCase();

        const sortedPlans = isUatPaymentsCategory ? sortByCustomOrder(plans) : plans;

        return (
          <div key={category} className="category-section">
            <div className={`${isMobile ? 'mt-6 mb-4 text-center' : 'mt-4 mb-8 text-left'}`}>
              <h1
                className={`font-bold text-black ${isMobile ? 'text-xl' : 'text-2xl'}`}
                style={{ fontSize: isMobile ? "24px" : "30px" }}
              >
                {category}
              </h1>
            </div>
            <div className={`grid gap-4 mt-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 justify-center`}>
              {sortedPlans.map((plan, index) => {
                const sharedProps = {
                  // key: index,
                  plan,
                  currentTab,
                  industry: plan.invoice_plan,
                  price: plan.invoice_plan_fixed_rate,
                  benefits: getBenefits(plan.invoice_plan, category),
                  planId: plan.org_invoice_plan_id,
                  onButtonClick: () => handleApplyClick(plan),
                   buttonLabel: isNetsCard(plan)
                    ? "Get started today"
                    : "Apply Course Code",
                  handleComingSoonClick,
                  isMobile, // Added isMobile prop
                };

                // USE COURSECARD FOR ALL CARDS TO MAINTAIN CONSISTENCY
                return plan.invoice_plan_category_id == 7 ? (
                  <ProjectApiCatalogueCard {...sharedProps} />
                ) : isNetsCard(plan) ? (
                  <PaymentsApiCatalogueCard key={index} {...sharedProps} />
                ) : (
                  <ComboApiCatalogueCard key={index} {...sharedProps} />
                );
              })}
            </div>
          </div>
        );
      })}

      {/* Modals */}
      {isOpen && (
        <ComingSoonModal
          setOpenModal={setOpen}
          comingSoonDate={comingSoonDate}
        />
      )}
      {isReuseProjModalOpen && (
        <RenewProjectModal
          setOpenModal={setReuseProjModalOpen}
          devProj={devProj}
          industryApiOptions={industryApiOptions}
          organisationApiOptions={organisationApiOptions}
          currentTab={currentTab}
          plan={developerPlan}
        />
      )}
      {isOpenMembershipCard && (
        <PayMembershipPlanModal
          setOpenModal={setOpenMembershipCard}
        />
      )}
    </>
  );
}